module.exports = __webpack_public_path__ + "img/team_5.28b91a4b.jpg";